module.exports = __webpack_public_path__ + "static/media/CvsWhite.f0c21b94.svg";